import { createContext, useContext, useReducer } from "react";

export const FileRunwaterStore = createContext<IContextProps>(null);

interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type, payload }

class Search {
    keywords: string;
    classesId: string;
    shop: any;
    goods:any;
};

interface IState {
    classesList: any[];
    search: Search;
}

const initialArgs = {
    classesList: [],
    search: new Search()
}

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        case "LoadClasses":
            return {
                ...state,
                classesList: payload
            }
        case "SetSearch":
            return {
                ...state,
                search: {
                    ...state.search,
                    ...payload
                }
            }
        default:
            return state;
    }
}

export function FileRunwaterStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <FileRunwaterStore.Provider value={v}>{props.children}</FileRunwaterStore.Provider>
}